﻿$.fn.dxCtrlStrConResumeModifExterne = function custom_dxCtrlStrConResumeModifExterne(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlstrconresumemodifexterne dx-ctrl");
        this.createInstance(new cdxCtrlStrConResumeModifExterne(this, option));
    }
    return this;
}

window.cdxCtrlStrConResumeModifExterne = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (!option.lstObligatoire) lstObligatoire = []

    var jauge = null
    var isDirtyNom = false
    var isDirtyPreNom = false
    var isDirtySociete = false
    var isDirtyNomSociete = false
    var isDirtySiret = false
    var isDirtyTvaIntra = false
    var isDirtyNomSociete = false
    var isDirtyAdresse = false
    var isDirtyTel = false

    this.isDirty = function () {
        return isDirtyNom || isDirtyPreNom || isDirtyAdresse || isDirtyTel || isDirtySociete || isDirtyNomSociete || isDirtySiret || isDirtyTvaIntra
    }

    var dxNom = null
    var dxPrenom = null
    var dxNomSociete = null
    var dxSiret = null
    var dxTvaIntra = null
    var dxAdr = null
    var dxCp = null
    var dxVille = null
    var dxPays = null
    var dxTel = null
    //l'adresse email n'est jamais modifié
    var disableValueChanged = false
    function mConstruit() {
        container.empty()
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({ height: 20, width: 20 }).dxCtrlJauge("instance")

        var $Table = $("<table style='width:100%;margin:10px;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:50%'/>").appendTo($Tr)
        dxNom = $("<div/>").appendTo($Td).dxCtrlTextBox({
            label: "Nom" + (option.lstObligatoire.contains("nom") ? " *" : ""),
            labelMode: "floating",
            value: (option.dataSaisie.nom ? option.dataSaisie.nom : ""),
            onValueChanged: function (e) {
                dxNom.element().css("background-color", "")
                isDirtyNom = true
                option.dataSaisie.nom = e.value
                if (option.onValueChanged) option.onValueChanged(option.dataSaisie)
            }
        }).dxCtrlTextBox("instance")
        var $Td = $("<td style='width:50%'/>").appendTo($Tr)
        dxPrenom = $("<div/>").appendTo($Td).dxCtrlTextBox({
            label: "Prénom" + (option.lstObligatoire.contains("prenom") ? " *" : ""),
            labelMode: "floating",
            value: (option.dataSaisie.prenom ? option.dataSaisie.prenom : ""),
            onValueChanged: function (e) {
                dxPrenom.element().css("background-color", "")
                isDirtyPreNom = true
                option.dataSaisie.prenom = e.value
                if (option.onValueChanged) option.onValueChanged(option.dataSaisie)
            }
        }).dxCtrlTextBox("instance")


        var dxChkSociete = $("<div style='margin:10px 10px 0 10px;'/>").appendTo(container).dxCheckBox({
            text: "Pour une société",
            value: option.dataSaisie.isSociete,
            onValueChanged: function (e) {
                option.dataSaisie.isSociete = e.value
                isDirtySociete = true
                if (option.onValueChanged) option.onValueChanged(option.dataSaisie)
                if (option.dataSaisie.isSociete) {
                    $TableSociete.slideDown(200)
                } else {
                    $TableSociete.slideUp(200)
                }
            }
        }).dxCheckBox("instance")

        var $TableSociete = $("<table style='width:100%;margin:10px;'/>").appendTo(container)
        if (!option.dataSaisie.isSociete) $TableSociete.hide()
        var $Tr = $("<tr/>").appendTo($TableSociete)
        var $Td = $("<td style='width:100%' colspan='2'/>").appendTo($Tr)
        dxNomSociete = $("<div style='padding:5px 0;'/>").appendTo($Td).dxCtrlTextBoxInseeList({
            bddCtrl: option.bddCtrl,
            labelMode: "floating",
            label: "Nom société",
            type: "",
            value: option.dataSaisie.nomSociete,
            onValueChanged: function (e) {
                dxNomSociete.element().css("background-color", "")
                isDirtyNomSociete = true
                if (!e.value) {
                    option.dataSaisie.nomSociete=""
                } else {
                    option.dataSaisie.nomSociete = e.value.nom
                    disableValueChanged=true
                    dxSiret.option("value", e.value.siret)
                    dxTvaIntra.option("value", e.value.tvaintra)
                    disableValueChanged=false
                }
                if (option.onValueChanged) option.onValueChanged(option.dataSaisie)
            }
        }).dxCtrlTextBoxInseeList("instance")

        var $Tr = $("<tr/>").appendTo($TableSociete)
        var $Td = $("<td style='width:50%'/>").appendTo($Tr)
        dxSiret = $("<div style='padding:5px 0;'/>").appendTo($Td).dxCtrlTextBoxInsee({
            bddCtrl: option.bddCtrl,
            labelMode: "floating",
            label: "Siret",
            placeholder: "",
            type:  "siret",
            value: option.dataSaisie.siret,
            libSearch: option.dataSaisie.nomSociete,
            onDemandeLibSearch: function () {
                return option.dataSaisie.nomSociete
            },
            onValueChanged: function (e) {
                dxSiret.element().css("background-color", "")
                isDirtyTvaIntra = true
                if (e.value == null || e.value.length == 0) {
                    option.dataSaisie.siret = ""
                } else {
                    option.dataSaisie.siret = e.value
                }
                if (!disableValueChanged && option.onValueChanged) option.onValueChanged(option.dataSaisie)
            }
        }).dxCtrlTextBoxInsee("instance")
        var $Td = $("<td style='width:50%'/>").appendTo($Tr)
        dxTvaIntra = $("<div style='padding:5px 0;'/>").appendTo($Td).dxCtrlTextBoxInsee({
            bddCtrl: option.bddCtrl,
            labelMode: "floating",
            label: "N° TVA intracommunautaire",
            placeholder: "",
            type: "tvaintra",
            value: option.dataSaisie.tvaintra,
            libSearch: option.dataSaisie.nomSociete,
            onDemandeLibSearch: function () {
                return option.dataSaisie.nomSociete
            },
            onValueChanged: function (e) {
                dxSiret.element().css("background-color", "")
                isDirtyTvaIntra = true
                if (e.value == null || e.value.length == 0) {
                    option.dataSaisie.tvaintra = ""
                } else {
                    option.dataSaisie.tvaintra = e.value
                }
                if (!disableValueChanged && option.onValueChanged) option.onValueChanged(option.dataSaisie)
            }
        }).dxCtrlTextBoxInsee("instance")

        var $Table = $("<table style='width:100%;margin:10px;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        dxAdr = $("<div/>").appendTo($Td).dxCtrlTextBox({
            label: "Adresse" + (option.lstObligatoire.contains("adr") ? " *" : ""),
            labelMode: "floating",
            value: (option.dataSaisie.adr ? option.dataSaisie.adr : ""),
            onValueChanged: function (e) {
                dxAdr.element().css("background-color", "")
                isDirtyAdresse = true
                option.dataSaisie.adr = e.value
                if (option.onValueChanged) option.onValueChanged(option.dataSaisie)
            }
        }).dxCtrlTextBox("instance")


        var $Table = $("<table style='width:100%;margin:10px;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:40%'/>").appendTo($Tr)
        dxCp = $("<div/>").appendTo($Td).dxCtrlTextBox({
            label: "Code postal" + (option.lstObligatoire.contains("cp") ? " *" : ""),
            labelMode: "floating",
            value: (option.dataSaisie.cp ? option.dataSaisie.cp : ""),
            onValueChanged: function (e) {
                dxCp.element().css("background-color", "")
                isDirtyAdresse = true
                option.dataSaisie.cp = e.value
                if (option.onValueChanged) option.onValueChanged(option.dataSaisie)
            }
        }).dxCtrlTextBox("instance")
        var $Td = $("<td style='width:60%'/>").appendTo($Tr)
        dxVille = $("<div/>").appendTo($Td).dxCtrlTextBox({
            label: "Ville" + (option.lstObligatoire.contains("ville") ? " *" : ""),
            labelMode: "floating",
            value: (option.dataSaisie.ville ? option.dataSaisie.ville : ""),
            onValueChanged: function (e) {
                dxVille.element().css("background-color", "")
                isDirtyAdresse = true
                option.dataSaisie.ville = e.value
                if (option.onValueChanged) option.onValueChanged(option.dataSaisie)
            }
        }).dxCtrlTextBox("instance")

        var $Table = $("<table style='width:100%;margin:10px;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:40%'/>").appendTo($Tr)
        dxPays = $("<div/>").appendTo($Td).dxCtrlSaisiePays({
            bddCtrl: option.bddCtrl,
            label: "Pays" + (option.lstObligatoire.contains("pays") ? " *" : ""),
            value: (option.dataSaisie.pays ? option.dataSaisie.pays : ""),
            onValueChanged: function (e) {
                dxPays.element().css("background-color", "")
                isDirtyAdresse = true
                option.dataSaisie.pays = e.value.name
                option.dataSaisie.code_pays = e.value.code
                if (option.onValueChanged) option.onValueChanged(option.dataSaisie)
            }
        }).dxCtrlSaisiePays("instance")

        //var dataTel = null
        //if (option.dataTemplate) {
        //    if (option.dataTemplate.mob_sms && option.dataTemplate.mob_sms.length > 0) {
        //        dataTel = {
        //            tel_code_pays: dataTemplate.mob_code_pays,
        //            tel_number: dataTemplate.mob_number,
        //            tel_complet: dataTemplate.mob_complet,
        //            tel_sms: dataTemplate.mob_sms,
        //            tel_error: dataTemplate.mob_error,
        //            tel_num_type: dataTemplate.mob_num_type,
        //        }
        //    } else if (option.dataTemplate.tel_sms && option.dataTemplate.tel_sms.length > 0) {
        //        dataTel = {
        //            tel_code_pays: dataTemplate.tel_code_pays,
        //            tel_number: dataTemplate.tel_number,
        //            tel_complet: dataTemplate.tel_complet,
        //            tel_sms: dataTemplate.tel_sms,
        //            tel_error: dataTemplate.tel_error,
        //            tel_num_type: dataTemplate.tel_num_type,
        //        }
        //    }
        //}

        var $Td = $("<td style='width:60%'/>").appendTo($Tr)
        dxTel = $("<div style='margin:3px;'/>").appendTo($Td).dxCtrlTelephone({
            labelMode: "floating",
            label: "Téléphone" + (option.lstObligatoire.contains("tel") ? " *" : ""),
            bddCtrl: option.bddCtrl,
            width: "100%",
            typeTel: "mob",
            disableVerifSaisie: true,
            value: (option.dataSaisie.datatel ? option.dataSaisie.datatel : null),
            onValueChanged: function (e) {
                dxTel.element().css("background-color", "")
                isDirtyTel = true
                option.dataSaisie.datatel = {
                    tel_code_pays: e.value.tel_code_pays,
                    tel_number: e.value.tel_number,
                    tel_complet: e.value.tel_complet,
                    tel_sms: e.value.tel_sms,
                    tel_error: e.value.tel_error,
                    tel_num_type: e.value.tel_num_type
                }
                if (option.onValueChanged) option.onValueChanged(option.dataSaisie)
            }
        }).dxCtrlTelephone("instance")
    }

    this.mColorObligatoire = function () {
        if (option.lstObligatoire.contains("nom") && (!dxNom.option("value") || dxNom.option("value").length == 0)) dxNom.element().css("background-color", "#ffcccc")
        if (option.lstObligatoire.contains("prenom") && (!dxPrenom.option("value") || dxPrenom.option("value").length == 0)) dxPrenom.element().css("background-color", "#ffcccc")
        if (option.lstObligatoire.contains("adr") && (!dxAdr.option("value") || dxAdr.option("value").length == 0)) dxAdr.element().css("background-color", "#ffcccc")
        if (option.lstObligatoire.contains("cp") && (!dxCp.option("value") || dxCp.option("value").length == 0)) dxCp.element().css("background-color", "#ffcccc")
        if (option.lstObligatoire.contains("ville") && (!dxVille.option("value") || dxVille.option("value").length == 0)) dxVille.element().css("background-color", "#ffcccc")
        if (option.lstObligatoire.contains("pays") && (!dxPays.option("value") || dxPays.option("value").length == 0)) dxPays.element().css("background-color", "#ffcccc")
        if (option.lstObligatoire.contains("tel") && !dxTel.hasValue()) dxTel.element().css("background-color", "#ffcccc")
    }

    this.mReload = function () { mConstruit() }

    this.element = function () { return container }

    mConstruit();
}


